<div class="order-detail-tax-list">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  @if (isSpinner) {
    <div class="kbm-search-loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <div class="d-flex justify-content-between align-items-center mb-2	">
    <div class="fw-bold">Order Detail Taxes</div>
    <button mat-icon-button focusable="false" tabindex="-1" class="close-button" type="button" [mat-dialog-close]="true">
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  </div>
  <div class="text-end">
    <span class="text-decoration-underline text-primary" style="cursor: pointer;font-size: 14px;"
    (click)="showTaxes()">{{expandTaxes ? 'Hide Taxes' : 'View Taxes'}}</span>
  </div>
  <hr class="my-0 py-1">

  <div>
    @if (treeTableData.length > 0) {
      <p-treeTable [value]="treeTableData" styleClass="p-datatable-striped">
        <ng-template pTemplate="header">
          <tr>
            <th class="text-nowrap name-cell">Name</th>
            <th>#</th>
            <th>Price</th>
            <th>$ Discount</th>
            <th>Total</th>
            <th>Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
          <tr [class.row-tax]="rowData.type === 'tax'">
            <td>
              @if (rowData.type !== 'tax') {
                <p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
              }
              <span [class.text-nowrap]="rowData.type === 'tax'" [class.font-weight-bold]="rowData.type === 'orderDetail'"
                [style.margin-left]="rowData.type === 'tax' ? '0.5rem' : '0'">
                {{rowData.name}}
              </span>
            </td>
            <td [class.font-weight-bold]="rowData.type === 'orderDetail'">{{rowData.quantity}}</td>
            <td>
              @if (rowData.type === 'orderDetail') {
                <span>{{rowData.listPrice | currency : 'USD' : 'symbol' :
                '1.2-2'}}</span>
              }
            </td>
            <td>
              @if (rowData.type === 'orderDetail') {
                <span>{{rowData.listPriceAdjustmentAmount | currency : 'USD' :
                'symbol' : '1.2-2'}}</span>
              }
            </td>
            <td>{{rowData.total | currency : 'USD' : 'symbol' : '1.2-2'}}</td>
            <td>
              @if (rowData.type === 'tax') {
                <span style="float:none">
                  <a>
                    <i class="pi pi-trash" aria-hidden="true"
                    style="color:blue; font-size:110%; padding-right:20px;" (click)="onRowDelete(rowData)"></i>
                  </a>
                  <a>
                    <i class="pi pi-pencil" aria-hidden="true"
                      style="color:blue; font-size:110%; padding-right:20px;"
                    (click)="onRowEdit(orderDetailTax)"></i>
                  </a>
                </span>
              }
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr style="background-color: #f8f9fa;">
            <td colspan="3"></td>
            <td><b>Total Amount</b></td>
            <td><b>{{totalAmount() | currency : 'USD' : 'symbol' : '1.0-2'}}</b></td>
            <td></td>
          </tr>
          <tr style="background-color: #f8f9fa;">
            <td colspan="3"></td>
            <td><b>Total Taxes</b></td>
            <td><b>{{totalTax() | currency : 'USD' : 'symbol' : '1.0-2'}}</b></td>
            <td></td>
          </tr>
          <tr style="background-color: #f8f9fa;">
            <td colspan="3"></td>
            <td><b>Grand Total</b></td>
            <td><b>{{grandTotal() | currency : 'USD' : 'symbol' : '1.0-2'}}</b></td>
            <td></td>
          </tr>
        </ng-template>
      </p-treeTable>
    }
  </div>

  <p-dialog
    header="Update Tax Percentage"
    [(visible)]="displayTaxPctPopUp"
    [style]="{ width: '500px', 'border-radius': '12px' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    >
    <div style="display: flex; flex-direction: column; gap: 1.5rem; padding: 1rem;">

      <!-- Input Field -->
      <div style="display: flex; flex-direction: column; gap: 0.5rem; width: 40%;">
        <label style="font-weight: 600; font-size: 14px;">Enter Tax Percentage</label>

        <input pInputText type="text" [(ngModel)]="taxPCT" placeholder="Enter tax percentage" (input)="onTaxInput($event)"
          style="width: 100%; padding: 0.75rem; border: 1px solid #ccc; border-radius: 6px;" />

        @if (taxError) {
          <small style="color: red; font-size: 12px;">{{ taxError }}</small>
        }
      </div>


      <!-- Update Button -->
      <div style="display: flex; justify-content: center;">
        <button
          pButton
          label="Update"
          icon="pi pi-check"
          (click)="updateTaxPercentage()" [disabled]="!isTaxValid"
          style="background-color: #007ad9; color: white; border: none; padding: 0.75rem 2rem; border-radius: 6px; font-weight: 600;"
        ></button>
      </div>

    </div>
  </p-dialog>





</div>